<template>
  <svg class="" width="100%" height="100%" :viewBox="viewBoxParams">
    <g v-if="showRelativity">
      <text x="0" y="0.6" text-anchor="start" font-family="sans-serif" font-weight="lighter"
        :fill="absolute ? 'black' : 'silver'"
        @click.prevent="setAbsolute(true)"
        class="pointer">
        Абсолютные
      </text>
      <text :x="viewBox.width.total" y="0.6" text-anchor="end" font-family="sans-serif" font-weight="lighter"
        :fill="!absolute ? 'black' : 'silver'"
        @click.prevent="setAbsolute(false)"
        class="pointer">
        Относительные
      </text>
    </g>
    <g v-for="(item, index) in items" :key=index>
      <text v-if="item.delimeter" x="0" :y="barsIndexOffset(index) + 0.6" font-family="sans-serif" font-weight="lighter" fill="black">
      </text>
      <g v-else>
        <rect :x="item.total.x" :y="barsIndexOffset(index)" :width="item.total.width" height="0.95" :fill="item.total.fill"></rect>
        <rect :x="item.progress.x" :y="barsIndexOffset(index)" :width="item.progress.width" height="0.95" :fill="item.progress.fill"></rect>
        <rect :x="item.total.x" :y="barsIndexOffset(index)" :width="item.total.width" height="0.95" @click="toggleBarr" fill="black" opacity="0">
        </rect>
        <text v-if="item.legenda" :x="item.legenda.x" :y="barsIndexOffset(index) + 0.6" text-anchor="start" font-family="sans-serif" font-weight="lighter" fill="black">
          {{ item.legenda.text }}
        </text>
        <text :x="item.progress.percent.x" :y="barsIndexOffset(index) + 0.6" text-anchor="start" font-family="sans-serif"  font-weight="normal" fill="black">
          {{ item.progress.percent.value.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/,'$1') }}%
        </text>
        <text :x="item.progress.label.x" :y="barsIndexOffset(index) + 0.6" font-family="sans-serif"  font-weight="lighter" fill="black">
          {{ item.progress.label.text }}
        </text>
        <text :x="item.total.label.x" :y="barsIndexOffset(index) + 0.6" text-anchor="end" font-family="sans-serif"  font-weight="lighter" fill="black">
          {{ item.total.label.text }}
        </text>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    series: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      viewBox: {
        width: {
          total: 12
        }
      },
      absolute: true
    }
  },
  computed: {
    showRelativity () {
      return this.series.data.length > 1
    },
    showSummary () {
      return this.series.data.length > 1
        ? 'showSummary' in this.series
          ? this.series.showSummary
          : true
        : false
    },
    fontSize () {
      return this.series.style.font && this.series.style.font.size ? this.series.style.font.size : '0.4'
    },
    viewBoxParams () {
      let additionalRows = 0
      additionalRows += this.showSummary === true ? 2 : 0
      additionalRows += this.showRelativity ? 1 : 0
      return `0 0 ${this.viewBox.width.total} ${this.series.data.length + additionalRows}`
    },
    max () {
      return this.series.data.reduce((sum, { total }) => {
        return total.value > sum ? total.value : sum
      }, 0)
    },
    items () {
      return this.series.data
        .map(({ progress, total, label }) => {
          return this.makeBarData({
            progress: progress,
            total: total,
            max: this.absolute ? this.max : total.value,
            legenda: label
          })
        })
        .concat([
          this.delimeterBar(),
          this.summary()
        ])
    }
  },
  methods: {
    toggleBarr (e) {
      if (e.target.getAttribute('opacity') === '0.2') {
        e.target.setAttribute('opacity', '0')
      } else {
        e.target.setAttribute('opacity', '0.2')
      }
    },
    summary () {
      const sum = this.series.data.reduce((acc, { total, progress }) => {
        return { total: acc.total + total.value, progress: acc.progress + progress.value }
      }, { total: 0, progress: 0 })

      return this.makeBarData({
        legenda: 'Сум',
        progress: { value: sum.progress },
        total: { value: sum.total },
        max: sum.total
      })
    },
    delimeterBar () {
      return { delimeter: true }
    },
    formatValue (value) {
      return this.series.format && this.series.format.value
        ? this.series.format.value(value || 0)
        : value || 0
    },
    makeBarData ({ legenda, progress, total, max }) {
      const chartOffset = legenda ? 3.5 : 1.5
      const chartWidth = this.viewBox.width.total - chartOffset
      const value = ((progress.value * 100 / max) || 0)
      return {
        legenda: legenda ? { text: legenda, x: 0 } : null,
        progress: {
          width: (progress.value / max * chartWidth) || 0,
          x: chartOffset,
          label: {
            text: this.formatValue(progress.value),
            x: chartOffset + 0.2
          },
          fill: this.series.style.color.progress,
          percent: { value: isFinite(value) ? value.toFixed(1) : '0', x: Math.max(0, chartOffset - 1.6) }
        },
        total: {
          width: (total.value / max * chartWidth) || 0,
          x: chartOffset,
          label: {
            text: this.formatValue(total.value),
            x: this.viewBox.width.total - 0.2
          },
          fill: this.series.style.color.total
        }
      }
    },
    barsIndexOffset (itemIndex) {
      return itemIndex + (this.showRelativity ? 1 : 0)
    },
    setAbsolute (val) {
      this.absolute = val
    }
  }
}
</script>

<style scoped>
text {
  font-size: 0.42px;
}

@media screen and (min-width: 30em) {
  text {
    font-size: 0.42px;
  }
}

@media screen and (min-width: 30em) and (max-width: 60em) {
  text {
    font-size: 0.42px;
  }
}

@media screen and (min-width: 60em) {
  text {
    font-size: 0.35px;
  }
}
</style>
